<div class="content">
    <app-message aria-live="polite" aria-atomic="true"></app-message>
    <app-loading></app-loading>
    <router-outlet></router-outlet>
</div>